import React, { useContext, useState, useEffect } from 'react'
import { BASE_URL_API } from '../../References/URLs'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import AuthContext from '../../store/auth-context'
import styles from './AccountSetting.module.css'
import { toast } from 'react-toastify'
import { FaToggleOff, FaToggleOn } from "react-icons/fa";

const AccountSetting = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

    const [loading, setLoading] = useState({})
    const [settings, setSettings] = useState({
        whatsappEnabled: false,
        smsEnabled: false,
        emailNotifications: false,
        pushNotifications: false,
        twoFactorAuth: false,
        autoBackup: true,
        dataRetention: '12',
        timezone: 'UTC',
        language: 'English'
    })
    const [showApiKey, setShowApiKey] = useState(false)
    const [accountData, setAccountData] = useState({
        planType: 'Professional',
        storageUsed: 2.4,
        storageLimit: 10,
        activeUsers: 8,
        userLimit: 25,
        apiCallsUsed: 45000,
        apiCallsLimit: 100000
    })


    const activateWhatsAppPlanForStore = async () => {
        const response = await fetch(BASE_URL_API + "activateWhatsAppPlanForStore",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx?.token,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                toast(`Successfully enabled!`)
                setSettings({...settings, whatsappEnabled : true })
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx?.logout()
                } else if (respo?.message === "already exists") {
                    toast(`Already Enabled!`)
                }
            }
            console.log(respo)
        }
    }

    const getStoreAccountSettings = async () => {
        const response = await fetch(BASE_URL_API + "getStoreAccountSettings",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx?.token,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setSettings(respo?.response)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx?.logout()
                }
            }
            console.log(respo)
        }
    }

    useEffect(() => {
        if(activeStore!==null) {
            getStoreAccountSettings()
        }
    }, [asCtx])
    
    console.log(settings)



    if (activeStore === null) {
        return (
            <div className={styles.mainWrapper}>
                <div className={styles.noStoreContainer}>
                    <div className={styles.noStoreContent}>
                        <div className={styles.noStoreIcon}>🏪</div>
                        <h3 className={styles.noStoreTitle}>No Store Selected</h3>
                        <p className={styles.noStoreMessage}>Please select a store to manage account settings.</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer}>
                {/* Header */}
                <div className={styles.headerWrapper}>
                    <div className={styles.headerContainer}>
                        <div className={styles.headerContent}>
                            <div className={styles.headerInfo}>
                                <div className={styles.headerIcon}>⚙️</div>
                                <div>
                                    <div className={styles.headerTitle}>Account Settings</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.contentWrapper}>
                    <div className={styles.gridContainer}>
                        {/* Main Settings */}
                        <div className={styles.mainContent}>
                            {/* Communication Settings */}
                            <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <h3 className={styles.cardTitle}>
                                        <span className={styles.cardIcon}>💬</span>
                                        Communication Channels
                                    </h3>
                                </div>
                                <div className={styles.cardContent}>
                                    {/* WhatsApp */}
                                    <div className={styles.settingItem}>
                                        <div className={styles.settingInfo}>
                                            <div className={styles.settingIconContainer}>
                                                <span className={styles.whatsappIcon}>📱</span>
                                            </div>
                                            <div>
                                                <h4 className={styles.settingTitle}>WhatsApp Business</h4>
                                                <p className={styles.settingDescription}>Send automated messages and notifications</p>
                                            </div>
                                        </div>
                                        <div className={styles.settingActions}>
                                            {settings?.whatsappEnabled ?
                                                <FaToggleOn size={36} color="#2463EB" onClick={() => activateWhatsAppPlanForStore()} />
                                                :
                                                <FaToggleOff size={36} color="#D1D5DB" onClick={() => activateWhatsAppPlanForStore()} />
                                            }
                                        </div>
                                    </div>

                                    {/* SMS */}
                                    <div className={styles.settingItem}>
                                        <div className={styles.settingInfo}>
                                            <div className={styles.settingIconContainer}>
                                                <span className={styles.smsIcon}>📞</span>
                                            </div>
                                            <div>
                                                <h4 className={styles.settingTitle}>SMS Messaging</h4>
                                                <p className={styles.settingDescription}>Send SMS notifications to customers</p>
                                            </div>
                                        </div>
                                        <div className={styles.settingActions}>
                                            {settings?.smsEnabled ?
                                                <FaToggleOn size={36} color="#2463EB" />
                                                :
                                                <FaToggleOff size={36} color="#D1D5DB" />
                                            }
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className={styles.settingItem}>
                                        <div className={styles.settingInfo}>
                                            <div className={styles.settingIconContainer}>
                                                <span className={styles.emailIcon}>✉️</span>
                                            </div>
                                            <div>
                                                <h4 className={styles.settingTitle}>Email Campaigns</h4>
                                                <p className={styles.settingDescription}>Automated email marketing and notifications</p>
                                            </div>
                                        </div>
                                        <div className={styles.settingActions}>
                                            {settings?.emailNotifications ?
                                                <FaToggleOn size={36} color="#2463EB" />
                                                :
                                                <FaToggleOff size={36} color="#D1D5DB" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Security Settings */}
                            {/* <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <h3 className={styles.cardTitle}>
                                        <span className={styles.cardIcon}>🔒</span>
                                        Security & Privacy
                                    </h3>
                                </div>
                                <div className={styles.cardContent}>
                                    <div className={styles.settingItem}>
                                        <div className={styles.settingInfo}>
                                            <div>
                                                <h4 className={styles.settingTitle}>Two-Factor Authentication</h4>
                                                <p className={styles.settingDescription}>Add an extra layer of security to your account</p>
                                            </div>
                                        </div>
                                        <div className={styles.settingActions}>
                                            <label className={styles.toggleSwitch}>
                                                <input
                                                    type="checkbox"
                                                    checked={settings.twoFactorAuth}
                                                    onChange={() => toggleSetting('twoFactorAuth')}
                                                />
                                                <span className={styles.toggleSlider}></span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className={styles.apiKeySection}>
                                        <h4 className={styles.settingTitle}>API Access Key</h4>
                                        <div className={styles.apiKeyContainer}>
                                            <input
                                                type={showApiKey ? "text" : "password"}
                                                value="sk_live_abcd1234567890efghijklmnopqrstuv"
                                                readOnly
                                                className={styles.apiKeyInput}
                                            />
                                            <button
                                                onClick={() => setShowApiKey(!showApiKey)}
                                                className={styles.apiKeyToggle}
                                            >
                                                {showApiKey ? '👁️' : '👁️‍🗨️'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* System Preferences */}
                            {/* <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <h3 className={styles.cardTitle}>
                                        <span className={styles.cardIcon}>🗄️</span>
                                        System Preferences
                                    </h3>
                                </div>
                                <div className={styles.cardContent}>
                                    <div className={styles.settingItem}>
                                        <div className={styles.settingInfo}>
                                            <div>
                                                <h4 className={styles.settingTitle}>Automatic Backup</h4>
                                                <p className={styles.settingDescription}>Daily backup of your CRM data</p>
                                            </div>
                                        </div>
                                        <div className={styles.settingActions}>
                                            <label className={styles.toggleSwitch}>
                                                <input
                                                    type="checkbox"
                                                    checked={settings.autoBackup}
                                                    onChange={() => toggleSetting('autoBackup')}
                                                />
                                                <span className={styles.toggleSlider}></span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className={styles.preferencesGrid}>
                                        <div className={styles.selectGroup}>
                                            <label className={styles.selectLabel}>Data Retention (months)</label>
                                            <select
                                                value={settings.dataRetention}
                                                onChange={(e) => setSettings(prev => ({ ...prev, dataRetention: e.target.value }))}
                                                className={styles.selectInput}
                                            >
                                                <option value="6">6 months</option>
                                                <option value="12">12 months</option>
                                                <option value="24">24 months</option>
                                                <option value="indefinite">Indefinite</option>
                                            </select>
                                        </div>
                                        <div className={styles.selectGroup}>
                                            <label className={styles.selectLabel}>Timezone</label>
                                            <select
                                                value={settings.timezone}
                                                onChange={(e) => setSettings(prev => ({ ...prev, timezone: e.target.value }))}
                                                className={styles.selectInput}
                                            >
                                                <option value="UTC">UTC</option>
                                                <option value="EST">Eastern Time</option>
                                                <option value="PST">Pacific Time</option>
                                                <option value="GMT">GMT</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                        {/* Sidebar */}
                        <div className={styles.sidebar}>
                            {/* Account Overview */}
                            <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <h3 className={styles.cardTitle}>
                                        <span className={styles.cardIcon}>👤</span>
                                        Account Overview
                                    </h3>
                                </div>
                                <div className={styles.cardContent}>
                                    <div className={styles.overviewItem}>
                                        <p className={styles.overviewLabel}>Auth Identifier</p>
                                        <p className={styles.overviewValue}>{authCtx?.authIdentifier}</p>
                                    </div>
                                    <div className={styles.overviewItem}>
                                        <p className={styles.overviewLabel}>Store ID</p>
                                        <p className={styles.overviewValueMono}>{activeStore?.storeIdentifier}</p>
                                    </div>
                                    <div className={styles.overviewItem}>
                                        <p className={styles.overviewLabel}>Current Plan</p>
                                        <span className={styles.planBadge}>
                                            {accountData.planType}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Usage Statistics */}
                            {/* <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <h3 className={styles.cardTitle}>
                                        <span className={styles.cardIcon}>💳</span>
                                        Usage & Limits
                                    </h3>
                                </div>
                                <div className={styles.cardContent}>
                                    <div className={styles.usageItem}>
                                        <div className={styles.usageHeader}>
                                            <span className={styles.usageTitle}>Storage</span>
                                            <span className={styles.usageStats}>{accountData.storageUsed}GB / {accountData.storageLimit}GB</span>
                                        </div>
                                        <div className={styles.progressBar}>
                                            <div
                                                className={styles.progressFill}
                                                style={{ width: `${(accountData.storageUsed / accountData.storageLimit) * 100}%` }}
                                            ></div>
                                        </div>
                                    </div>

                                    <div className={styles.usageItem}>
                                        <div className={styles.usageHeader}>
                                            <span className={styles.usageTitle}>Active Users</span>
                                            <span className={styles.usageStats}>{accountData.activeUsers} / {accountData.userLimit}</span>
                                        </div>
                                        <div className={styles.progressBar}>
                                            <div
                                                className={`${styles.progressFill} ${styles.progressGreen}`}
                                                style={{ width: `${(accountData.activeUsers / accountData.userLimit) * 100}%` }}
                                            ></div>
                                        </div>
                                    </div>

                                    <div className={styles.usageItem}>
                                        <div className={styles.usageHeader}>
                                            <span className={styles.usageTitle}>API Calls</span>
                                            <span className={styles.usageStats}>{accountData.apiCallsUsed.toLocaleString()} / {accountData.apiCallsLimit.toLocaleString()}</span>
                                        </div>
                                        <div className={styles.progressBar}>
                                            <div
                                                className={`${styles.progressFill} ${styles.progressYellow}`}
                                                style={{ width: `${(accountData.apiCallsUsed / accountData.apiCallsLimit) * 100}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* Quick Actions */}
                            {/* <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <h3 className={styles.cardTitle}>Quick Actions</h3>
                                </div>
                                <div className={styles.cardContent}>
                                    <button className={styles.quickAction}>
                                        <span className={styles.quickActionIcon}>👥</span>
                                        <span className={styles.quickActionText}>Manage Team</span>
                                    </button>
                                    <button className={styles.quickAction}>
                                        <span className={styles.quickActionIcon}>🧾</span>
                                        <span className={styles.quickActionText}>Billing & Invoices</span>
                                    </button>
                                    <button className={styles.quickAction}>
                                        <span className={styles.quickActionIcon}>📤</span>
                                        <span className={styles.quickActionText}>Export Data</span>
                                    </button>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AccountSetting